import { diagnosticsStore } from '@platform/core/diagnostics';
import { useStore } from '@platform/react/useStore';
import { Icon } from '@platform/ui-kit/Icon';
import type { BootState } from './boot';
import css from './BootScreen.module.css';

/** Before the kiosk exists: what it is waiting for, or why it could not start. */
export function BootScreen({ state }: { state: Exclude<BootState, { phase: 'ready' }> }) {
  const problems = useStore(diagnosticsStore, (d) => d.filter((x) => x.level !== 'info').slice(-5));
  const failed = state.phase === 'failed';
  return (
    <main className={css.boot} role={failed ? 'alert' : 'status'}>
      <span className={failed ? css.failed : css.spin}><Icon name={failed ? 'warning' : 'loading'} size={72} /></span>
      <h1>{failed ? state.message : state.detail}</h1>
      {failed && state.detail && <p>{state.detail}</p>}
      {problems.length > 0 && (
        <ul className={css.problems}>
          {problems.map((p) => <li key={p.id}><b>{p.source}</b> {p.message}</li>)}
        </ul>
      )}
      {failed && <button className={css.retry} onClick={() => window.location.reload()}><Icon name="restart" />Riprova</button>}
    </main>
  );
}
